// @ts-check

// import { useEffect, useMemo, useState } from 'react';
// import PropTypes from 'prop-types';
// import { reduxForm } from 'redux-form';

import React, { useEffect, useMemo, useState } from 'react';
import { Controller, set, useForm } from 'react-hook-form';

import { api as itemCommentsDialogApi } from '../../../../js/actions/Dialogs/itemCommentsDialogActions';

// import FormControl from 'react-bootstrap/FormControl';

// import cn from 'classnames';

// import moment from 'moment';
// import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
// import Validation from 'infrastructure/js/components/controls/controlsValidations';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import InputSection from 'infrastructure/js/components/Dialog/InputSection/inputSection';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
// import { enumTypes, getEnumValue } from '../../../utils/enumHelper';
// import {isTouchApp} from 'infrastructure/js/utils/appHelper';

import PL_TextAreaField_Hook from 'infrastructure/js/components/controls/TextAreaField/textAreaField_Hook.js';


import Button from 'infrastructure/js/components/controls/Button/button.js';


import './temCommentsDialog.scss';
import { useAutoResizeTextArea } from './useAutoResizeTextArea';


/**
 * @typedef {import('./ItemCommentDialogTypes').ItemComment} ItemComment
 * 
 * @typedef {import('mat/js/types/HookFormTypes').HookFormInstance} HookFormInstance
 * 
 */

const COMMENT_MAX_LENGTH = 1000;


// const ItemCommentsDialog = ({ sData, show, actions, handleSubmit, initialize }) => {
export default function ItemCommentsDialog(props) {

  // console.log('ItemCommentsDialog props ===> ', props);

  // let { sData, show, actions, handleSubmit, initialize } = props;
  let { sData, show } = props;

  // show = true; // DEV
  if (!show) {
    return null;
  }


  // console.log('sData ===> ', sData.toJS());
  let comments = sData.get('comments') || [];
  // console.log('comments ===> ', comments);

  let itemDisplayName = sData.get('itemDisplayName') || null;

  let lastCommentSavedOn = sData.get('lastCommentSavedOn');

  let refDoResizeTextArea = useAutoResizeTextArea('txtComment', [props], { bottomMargin: 10 });



  let form = useForm();
  // console.log('FFF ===> ', form);


  // Clear the comment input after the last comment was saved
  useEffect(() => {
    form.resetField('txtComment');
    refDoResizeTextArea.current(); // Resize the textarea after resetting the field
  }, [form, lastCommentSavedOn]);




  // if (__DEV__) {
  //   window.FFF = form;
  // }


  // const { submit, hide } = actions;
  // const itemData = sData.get('itemToEdit');


  let labels = useMemo(() => {

    let labels = createLabelHelper('mat.item_comments.dialog.');

    return {
      title: labels.get('title'),
      hint_add_comment: labels.get('hint_add_comment'),
      no_comments_yet: labels.get('no_comments_yet'),
      save: labels.get('save'),
      cancel: labels.get('cancel'),
      errors__error_loading_comments: labels.get('errors.error_loading_comments'),
      validation__max_length: labels.get('validation.max_length', '', {
        commentMaxLength: COMMENT_MAX_LENGTH,
      }),
    };

  }, []);



  let doSubmit = (data) => {
    // console.log('SUBMIT data ===> ', data);

    let itemId = sData.get('itemId');
    let itemType = sData.get('itemType');

    itemCommentsDialogApi.submitAddComment({
      itemType: itemType,
      itemId: itemId,
      comment: data.txtComment.trim(),

    });


  };



  let handleHide = () => {
    itemCommentsDialogApi.hide();
  };

  let handleCancel = () => {
    handleHide();
  };



  /** 
   * @type {[boolean | undefined, Function]}
   */
  let [submitDisabled, setSubmitDisabled] = useState(true);

  let commentValue = form.watch('txtComment');
  useEffect(() => {
    // console.log('commentValue EFF ===> ', commentValue);
    let cleanComment = commentValue?.trim() || '';
    if (cleanComment.length > 0) {
      setSubmitDisabled(false);
      return;
    }
    setSubmitDisabled(true);

  }, [commentValue])



  useEffect(() => {
    // Focus the comment input when the dialog is shown
    if (show) {
      setTimeout(() => {
        let commentInput = document.getElementById('txtComment');
        if (commentInput) {
          commentInput.focus();
        }
        // refDoResizeTextArea.current(); // Resize the textarea after focusing
      }, 100); // Delay to ensure the dialog is fully rendered
    }

  }, [sData])





  let renderInputs = () => {

    return (<>

      <InputSection htmlFor="add-comment" className="add-comment-section">

        <PL_TextAreaField_Hook
          form={form}
          id="txtComment"
          name="txtComment"
          className="textarea-comments"
          // placeholder="Add a comment..."
          placeholder={labels.hint_add_comment}
          rules={{
            // required: 'Comment is required',
            // minLength: {
            //   value: 5,
            //   message: 'Comment must be at least 5 characters long',
            // },
            maxLength: {
              value: COMMENT_MAX_LENGTH,
              message: labels.validation__max_length,
            },
          }}


        />


        <div className="comment-actions-inputs-wrapper">
          <div className='left-section'>
            
            <Button
              id="btnCancelComment"
              variant={'secondary'}
              onClick={handleCancel}
            >{labels.cancel}</Button>
            
          </div>
          <div className='right-section'>
            
            <Button
              id="btnAddComment"
              variant={'primary'}
              disabled={submitDisabled}
              onClick={form.handleSubmit(doSubmit)}
            >{labels.save}</Button>
            
          </div>
        </div>





      </InputSection>

    </>);

  };

  /** 
   * @param {ItemComment[]} comments
   */
  let renderComments = (comments) => {

    if (!comments || comments.length === 0) {
      return (
        <div className="comments-display-wrapper">
          <div className="no-comments">{labels.no_comments_yet}</div>
        </div>
      );
    }


    return (<>
      <div className="comments-display-wrapper">

        {comments.map((comment, index) => {
          return renderComment(comment, index);
        })}

      </div>
    </>);

  };


  /** 
   * @param {ItemComment} itemComment
   * @param {number} index
   */
  let renderComment = (itemComment, index) => {

    return (
      <div className="comments-display-item" key={index}>
        <div className='username'>
          {itemComment.createdByUser}
        </div>
        <div className='time'>
          {itemComment.createdDateString}
        </div>
        <div className='comment'>
          {itemComment.comment}
        </div>
      </div>
    );

  };


  // let title  = useMemo(() => {
  //   let itemId = sData.get('itemId');
  //   let itemType = sData.get('itemType');

  //   if (itemDisplayName) {
  //     return `${labels.title} for ${itemDisplayName}`;
  //   }

  //   return `${labels.title} for ${itemType} #${itemId}`;
  // }, [sData, itemDisplayName, labels.title]);



  return (
    <Dialog
      id="item-comments-dialog"
      className="item-comments-dialog"
      titleText={labels.title}
      // titleText={title}
      show={show}
      onHide={handleHide}
      // loading={sData.get('loading')}
      sData={sData}
      // footerButtons={dialogButtons}
      footerButtons={{}}
    >


      {renderInputs()}
      {renderComments(comments)}


    </Dialog>
  );
};








